import * as React from "react";
import {
  Toolbar,
  ToolbarButton,
  ExportCsv,
  ExportPrint,
  GridToolbarProps,
} from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

export interface ExportToolbarProps extends GridToolbarProps {
  fileName?: string;
}

// A grid toolbar with only the Export menu, for grids that already have their
// own search and filter controls. Exports the rows currently in the grid.
const ExportToolbar = ({ fileName }: ExportToolbarProps) => {
  const [open, setOpen] = React.useState(false);
  const triggerRef = React.useRef<HTMLButtonElement>(null);

  return (
    <Toolbar>
      <Tooltip title="Export">
        <ToolbarButton
          ref={triggerRef}
          id="export-menu-trigger"
          aria-label="Export"
          aria-controls="export-menu"
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={() => setOpen(true)}
        >
          <FileDownloadIcon fontSize="small" />
        </ToolbarButton>
      </Tooltip>
      <Menu
        id="export-menu"
        anchorEl={triggerRef.current}
        open={open}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ list: { "aria-labelledby": "export-menu-trigger" } }}
      >
        <ExportPrint
          render={<MenuItem />}
          options={{ fileName }}
          onClick={() => setOpen(false)}
        >
          Print
        </ExportPrint>
        <ExportCsv
          render={<MenuItem />}
          options={{ fileName }}
          onClick={() => setOpen(false)}
        >
          Download as CSV
        </ExportCsv>
      </Menu>
    </Toolbar>
  );
};

export default ExportToolbar;
